enum SentryConfig {
  DSN = "https://142d3232dbad178aae0b736c12a7931b@o4509055607308288.ingest.de.sentry.io/4509055611764816",
}

export { SentryConfig };
